import { observer } from 'mobx-react';
import { Button, notification, Tooltip } from 'antd';
import { RecordCard } from '@project/store/shared/RecordCard';
import { PlaceIcon } from '@assets/icons/map/Place';
import { PrinterIcon } from '@assets/icons/content/Printer';
import { RouteIcon } from '@assets/icons/map/Route';
import '@assets/scss/index.scss';
import './style.scss';
import { GeoJSONConverter, MapUtils } from '@datum-group/datum-map/lib';
import { MapStore } from '../../../store/Map';
import { FC } from 'react';
import { INIT_MAP_DATA } from '@project/store';

interface ToolsPanelProps {
  card: RecordCard;
  map: MapStore;
  onRoute(): void;
}

const FROM = 'EPSG:4326';
const TO = INIT_MAP_DATA.srid;

export const ToolsPanel: FC<ToolsPanelProps> = observer(function ToolsPanel({
  card,
  map,
  onRoute,
}) {
  const isPoint = card.record.geometry?.type === 'Point';

  const handlePrintClick = () => {
    window.open(
      `#/print/?table=${card.tableName}&record=${card.record.recordId}`,
      '_blank',
    );
  };

  const handleGoToGeomClick = () => {
    const converter = new GeoJSONConverter();
    const geom = card.record.record?.geometry;

    if (!geom) {
      notification.error({
        title: 'Отсутствует геометрия',
      });

      throw new Error('Отсутствует геометрия');
    }

    const convertedGeom = converter.convertGeometry(FROM, TO, geom);

    if (convertedGeom.type === 'Point') {
      map.mapProperties.map.getView().animate({
        center: convertedGeom.coordinates,
        duration: 400,
        zoom: 18,
      });

      return;
    }

    map.mapProperties.extent = new MapUtils(
      map.mapProperties.map,
    ).geomsToExtend([convertedGeom]);
  };

  return (
    <div className="card-control-button">
      <Tooltip placement="bottomLeft" title="Показать на карте">
        <Button
          type="text"
          onClick={handleGoToGeomClick}
          icon={<PlaceIcon />}
        />
      </Tooltip>
      {isPoint && (
        <Tooltip placement="bottomLeft" title="Построить маршрут">
          <Button type="text" icon={<RouteIcon />} onClick={onRoute} />
        </Tooltip>
      )}
      {/* <Tooltip placement="bottomLeft" title="Ссылки">
          <Button type="text" icon={<LinkIcon />} onClick={() => {}} />
        </Tooltip>  */}
      <Tooltip placement="bottomLeft" title="Печать карточки объекта">
        <Button type="text" icon={<PrinterIcon />} onClick={handlePrintClick} />
      </Tooltip>
    </div>
  );
});
